import smoothscroll from "smoothscroll-polyfill";
import SmoothScroll from "smooth-scroll";

export function smooth() {
  smoothscroll.polyfill();

  const scroll = new SmoothScroll('a[href*="#"]', {
    speed: 300,
    updateURL: false,
    offset: () => {
        const header = document.querySelector('#header');

        const headerHeight = header ? header.offsetHeight : 0;

        return headerHeight;
      },
  });
}
